import getters from "./getters.js";
import actions from "./actions.js";
import mutations from "./mutations.js";

export default {
    namespaced: true,
    state() {
        return {
            keyword: [], 
            bannedWord: [], 
            keywordTags: [], // Ensure this is initialized as an empty array
            keywordTagTypes: [],
            variationVal: []
        };
    },
    // computed:{
    //     keywordTags()
    //     {
    //         return this.state.keywordTags;
    //     }
    // },


    getters,
    actions,
    mutations
}